/**
 * Returns if the current url is equal to Inpection page (including result).
 */
const isInspectionUrl = (location: any = window.location) => {
  return location.pathname.startsWith('/inspection');
};

export default isInspectionUrl;
